export class InvalidArgumentException extends Error {
	constructor(message: string = 'One of the provided arguments is invalid') {
		super(message);
		this.name = 'InvalidArgumentException';
	}
}
